<script>
import {
  mapActions, mapGetters, mapState,
} from 'vuex';

import i18n from '../i18n';
import store from '../store';
import { log } from '../log';
// eslint-disable-next-line import/no-unresolved

export default {
  i18n,
  store,
  name: 'Authed',
  props: ['propRegistered'],
  data: () => ({
    regChanged: false,
    popUpClosedTimer: null,
  }),
  computed: {
    ...mapState([
      'state',
      'registered',
      'isPopUpOpen',
      'accountServerPayload',
      'accountRegisterPayload',
      'accountUnregisterPayload',
      'iframeUrl',
    ]),
    ...mapGetters(['stateData']),
    computedReg() { // rely on prop before the VUEX state kicks in
      if (this.registered === null) {
        return !!this.propRegistered;
      }
      return this.registered;
    },
    buttonPayload() {
      if (this.stateData.error) return this.accountServerPayload;
      if (this.computedReg) return this.accountUnregisterPayload;
      return this.accountRegisterPayload;
    },
    buttonText() {
      if (this.stateData.error) return this.$t('fixError');
      if (this.isPopUpOpen) return this.$t('backToPopUp');
      if (this.state === 'ENOKEYFILE') return this.$t('getStarted');
      if (this.computedReg) return this.$t('signOut');
      return this.$t('signIn');
    },
    buttonTitle() {
      return this.$t('upc.opensNewHttpsWindow.base', [this.buttonText]);
    },
  },
  watch: {
    /**
     * @description determines whether we should reload the webGUI when closing pop-up
     */
    isPopUpOpen(newVal) {
      if (!newVal && this.regChanged) { // only watching the closure of the pop-up
        log.debug('[REGISTERED CHANGED] 🔥 reload webGUI settings');
        window.location.reload();
      }
    },
    registered(newVal, oldVal) {
      if (oldVal !== null && newVal !== this.propRegistered) {
        log.debug('[REGISTERED CHANGED]', { newVal, oldVal });
        this.regChanged = true;
        /** check if we should reload because the webGUI was slightly too slow
         * or because the settings page is open in another tab/window */
        if (!this.isPopUpOpen) {
          log.debug('[REGISTERED CHANGED] 🔥🔥 reload webGUI settings');
          window.location.reload();
        }
      }
    },
  },
  methods: {
    ...mapActions([
      'closePopUp',
      'openPopUp',
    ]),
  },
};
</script>

<template>
  <transition appear name="fade" mode="out-in">
    <div>
      <a
        v-if="iframeUrl"
        :href="iframeUrl"
        target="_blank"
        rel="noopener noreferrer"
        :title="buttonTitle"
        class="button"
      >{{ buttonText }} (new tab)</a>
      <button
        v-else
        @click="openPopUp(buttonPayload)"
        class="button"
        type="button"
        :title="buttonTitle"
      >{{ buttonText }}</button>
      <transition name="fade" mode="out-in">
        <button
          v-if="isPopUpOpen"
          @click="closePopUp()"
          class="button ml-8px"
          type="button"
        >{{ $t('closePopUp') }}</button>
      </transition>
    </div>
  </transition>
</template>

<style lang="postcss" scoped>
.button {
  font-family: clear-sans;
  font-size: 1.1rem;
  font-weight: bold;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  min-width: 86px;
  margin: 0 12px 10px 0;
  padding: 8px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  border-radius: 4px;
  border: none;
  color: #ff8c2f;
  background: -webkit-gradient(linear,left top,right top,from(#e22828),to(#ff8c2f)) 0 0 no-repeat,-webkit-gradient(linear,left top,right top,from(#e22828),to(#ff8c2f)) 0 100% no-repeat,-webkit-gradient(linear,left bottom,left top,from(#e22828),to(#e22828)) 0 100% no-repeat,-webkit-gradient(linear,left bottom,left top,from(#ff8c2f),to(#ff8c2f)) 100% 100% no-repeat;
  background: linear-gradient(90deg,#e22828 0,#ff8c2f) 0 0 no-repeat,linear-gradient(90deg,#e22828 0,#ff8c2f) 0 100% no-repeat,linear-gradient(0deg,#e22828 0,#e22828) 0 100% no-repeat,linear-gradient(0deg,#ff8c2f 0,#ff8c2f) 100% 100% no-repeat;
  background-size: 100% 2px,100% 2px,2px 100%,2px 100%;
}
.button:hover {
  color: #f2f2f2;
  background: -webkit-gradient(linear,left top,right top,from(#e22828),to(#ff8c2f));
  background: linear-gradient(90deg,#e22828 0,#ff8c2f);
}

/*! purgecss start ignore */
.fade-enter-active, .fade-leave-active {
  transition: opacity .15s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
@media (prefers-reduced-motion) {
  * { transition-duration: 0 !important }
}

[v-cloak] { display: none }
/*! purgecss end ignore */
</style>
